import { Injectable } from '@angular/core';
import { Resolve } from '@angular/router';
import { Observable, of } from 'rxjs';

/** Route resolve payload for ecommerce dashboard (reserved for future prefetched data). */
export interface EcommerceDashboardResolvedData {}

@Injectable()
export class EcommerceDashboardResolver implements Resolve<EcommerceDashboardResolvedData> {
  resolve(): Observable<EcommerceDashboardResolvedData> {
    return of({});
  }
}
